(function () {
  'use strict';
  if (window.olTrustpilotReady) return;
  window.olTrustpilotReady = true;
  var source = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  function prepare() {
    var theme = document.documentElement.hasAttribute('data-ol-nacht') ? 'dark' : 'light';
    document.querySelectorAll('[data-ol-tp] .trustpilot-widget').forEach(function (element) {
      var next = element.getAttribute('data-ol-tp-fixed-theme') || theme;
      var changed = element.getAttribute('data-theme') !== next;
      element.setAttribute('data-theme', next);
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function' && (changed || !element.querySelector('iframe'))) window.Trustpilot.loadFromElement(element, true);
    });
  }
  function start() {
    prepare();
    if (!document.querySelector('script[src="' + source + '"]')) {
      var script = document.createElement('script');
      script.src = source; script.async = true; script.onload = prepare;
      document.head.appendChild(script);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  new MutationObserver(prepare).observe(document.documentElement, {attributes:true, attributeFilter:['data-ol-nacht']});
  document.addEventListener('shopify:section:load', start);
})();
